import { render } from "./IncomeView.vue?vue&type=template&id=470a714c&scoped=true"
import script from "./IncomeView.vue?vue&type=script&lang=js"
export * from "./IncomeView.vue?vue&type=script&lang=js"

import "./IncomeView.vue?vue&type=style&index=0&id=470a714c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470a714c"]])

export default __exports__